export default "__VITE_ASSET__DM3ODs$y__"